export const getElementById = (id?: string): HTMLElement | null => {
  if (typeof window === 'undefined' || !id) {
    return null;
  }

  return document.getElementById(id);
};
